import { createFileRoute } from '@tanstack/react-router';
import { lazy, Suspense } from 'react';

import { PageSkeleton } from '~/components/common/page-skeleton/page-skeleton';

const SftpConnectionScreen = lazy(
  () => import('~/features/item-setup/pages/sftp-connection-screen'),
);

export const Route = createFileRoute('/_authenticated/_tenant/item-setup/sftp')({
  component: () => (
    <Suspense fallback={<PageSkeleton />}>
      <SftpConnectionScreen />
    </Suspense>
  ),
});
